import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { BankMutationKeys } from '../../../keys'
import {
	UpdateBankAccountRequest,
	UpdateBankAccountResponse,
} from '../../../type'
import { updateBankAccount } from '../../services'

interface UseMutationUpdateBankAccountProps {
	id: string
	payload: UpdateBankAccountRequest
}

export default function useMutationUpdateBankAccount(
	props?: UseBaseMutationOptions<
		UpdateBankAccountResponse,
		UseMutationUpdateBankAccountProps
	>,
) {
	return useMutation({
		mutationKey: [BankMutationKeys.UpdateBankAccount],
		mutationFn: (params) => updateBankAccount(params.id, params.payload),
		...props,
	})
}
